import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { SpeakerService } from '../../speaker.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SnackbarService } from '../../snackbar.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
	selector: 'app-list-container',
	templateUrl: './list-container.component.html',
	styleUrls: ['./list-container.component.css']
})
export class ListContainerComponent implements OnInit, OnDestroy {

	@ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
	@ViewChild(MatSort, { static: true }) sortComponent!: MatSort;

	length = 0;
	pageSize = 10;
	pageIndex = 0;
	pageSizeOptions = [10, 25, 50];
	showFirstLastButtons = true;
	selectedIds: number[] = [];
	public allIds: number[] = [];
	public activeView = true;
	public sortQuery = '';

	public displayColumns: any[] = [];
	public displayHeaders: any[] = [];
	public listData: any[] = [];
	public afterCall: any = [];
	dataSource = new MatTableDataSource<any>(this.listData);
	selection = new SelectionModel<any>(true, []);
	displayColumnsWithSelect = ['select'];
	displayHeadersWithSelect: any = [];
	IsWait = false;
	hideCreateBtnFor = [
		'/invoice',
		'/jobschedule'
	];
	hideActiveToggleFor = [
		'/challan',
		'/invoice',
		'/joborder',
		'/proforma',
		'/account_receipt',
		'/note',
		'/balance',
		'/sales_return',
		'/jobschedule'
	];
	hideSelectColumnFor = [
		'/jobschedule'
	];
	showBulkAction = [
		'/challan',
		'/proforma',
	];
	dateColumns = ['job_date', 'delivery_date', 'created_at', 'modified_at', 'challan_date', 'invoice_date', 'receipt_date', 'voucher_date', 'sales_return_date'];

	/** Columns whose raw enum/snake_case values should be title-cased for display */
	enumColumns = ['job_type', 'status', 'procedure'];

	dialogBoxResult: any;
	private destroy$ = new Subject<void>();

	constructor(
		public speaker: SpeakerService,
		private api: CommonApiService,
		public router: Router,
		private dialog: MatDialog,
		private snackbar: SnackbarService,
	) { }

	ngOnInit(): void {
		this.displayHeaders = this.speaker.displayHeaders;
		this.displayColumns = this.speaker.displayColumns;

		this.speaker.listData$.pipe(takeUntil(this.destroy$)).subscribe((data) => this.handleListData(data));
		this.speaker.clearSelection$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.selection.clear();
			this.selectedIds = [];
		});

		this.initializeData();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	initializeData() {
		this.listData = [];
		this.dataSource = new MatTableDataSource<any>([]);
		this.pageIndex = this.speaker.pageIndex ?? 0;
		this.length = 0;
		this.pageSize = this.speaker.pageSize || 10;
		this.allIds = [];
		this.sortQuery = this.speaker.sortQuery || '';
		this.activeView = this.speaker.activeView ?? true;
		const currentUrl = this.router.url.split('?')[0];
		const hideSelect = this.hideSelectColumnFor.some(p => currentUrl === p || currentUrl.startsWith(p + '/'));
		if (this.speaker.showActionColumn) {
			this.displayColumnsWithSelect = hideSelect
				? ['action', ...this.displayColumns]
				: ['action', 'select', ...this.displayColumns];
		} else {
			this.displayColumnsWithSelect = hideSelect
				? [...this.displayColumns]
				: ['select', ...this.displayColumns];
		}
		this.IsWait = true;
	}

	handleListData(data: any) {
		const list = data && data.data ? data.data : [];
		this.listData = list;
		this.dataSource = new MatTableDataSource<any>(this.listData);
		this.length = data?.length ?? 0;
		this.pageIndex = data?.pageIndex ?? 0;
		this.pageSize = data?.pageSize ?? this.pageSize;
		this.sortQuery = data?.sortQuery ?? this.sortQuery;
		this.allIds = data?.allIds ?? [];
		this.IsWait = false;

		this.selection.clear();
		if (Array.isArray(this.dataSource.data)) {
			this.dataSource.data.forEach(row => {
				if (this.selectedIds.includes(row.id)) {
					this.selection.select(row);
				}
			});
		}
	}

	handlePageEvent(pagination_event: PageEvent) {
		this.length = pagination_event.length;
		this.pageSize = pagination_event.pageSize;
		this.pageIndex = pagination_event.pageIndex;
		this.IsWait = true;
		this.speaker.emitPaginationChange(this.pageIndex, this.pageSize, this.sortQuery);
	}

	onSortChange(sort: Sort) {
		const direction = sort.direction === 'asc' ? '1' : sort.direction === 'desc' ? '-1' : '';
		this.sortQuery = direction ? `${sort.active}:${direction}` : 'id:1';
		this.IsWait = true;
		this.speaker.emitPaginationChange(this.pageIndex, this.pageSize, this.sortQuery);
	}

	public doFilter = (event: Event) => {
		const value = (event.target as HTMLInputElement).value;
		if (typeof value === 'string') {
			this.dataSource.filter = value.trim().toLocaleLowerCase();
		}
	};

	isAllSelected() {
		return this.selection.selected.length === this.dataSource.filteredData.length;
	}

	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
			this.selectedIds = [];
		} else {
			this.dataSource.filteredData.forEach(row => {
				if (!this.selection.isSelected(row)) {
					this.selection.select(row);
					this.selectedIds.push(row.id);
				}
			});
		}
	}

	toggleSelection(row: any) {
		this.selection.toggle(row);
		if (this.selection.isSelected(row)) {
			this.selectedIds.push(row.id);
		} else {
			const index = this.selectedIds.indexOf(row.id);
			if (index > -1) {
				this.selectedIds.splice(index, 1);
			}
		}
	}

	rowClicked(objId: number) {
		this.router.navigate([`/${this.speaker.model}`, objId]);
	}

	create() {
		this.router.navigate([`/${this.speaker.model}`, 'create']);
	}

	onToggleActive(ev: any) {
		this.activeView = !!ev.checked;
		this.speaker.setActiveView(this.activeView);
		this.pageIndex = 0;
		this.IsWait = true;
		try { this.paginator.firstPage(); } catch { }
		this.selection.clear();
		this.selectedIds = [];
		this.speaker.emitPaginationChange(0, this.pageSize, this.sortQuery);
	}

	changeStatus(status: any) {
		if (this.selectedIds.length === 0) {
			this.snackbar.warning('Please select at least one record');
			return;
		}

		if (this.selectedIds.length !== 0 && status !== '') {
			const actionLabel = status === 'active' ? 'activate' : 'deactivate';
			const message = `Please enter a remark to ${actionLabel} ${this.selectedIds.length} record(s).`;
			const dialogConfig = new MatDialogConfig();
			dialogConfig.data = {
				title: status === 'active' ? 'Activate Records' : 'Deactivate Records',
				message: message,
				requireRemark: true,
				remarkLabel: 'Status Change Remark',
				remarkPlaceholder: status === 'active'
					? 'Reason for activating these record(s)'
					: 'Reason for deactivating these record(s)',
			};
			const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
			dialogRef.afterClosed().subscribe(dialogResult => {
				this.dialogBoxResult = dialogResult;
				if (this.dialogBoxResult) {
					const payload = {
						selectedIds: this.selectedIds,
						status: status,
						remark: this.dialogBoxResult.remark,
					};
					this.api.callRoute(`${this.speaker.model}`, `/changeStatus`, payload).subscribe(
						(resp: any) => {
							if (resp.status !== 'error') {
								this.snackbar.success('Status updated Successfully!');
								this.redirectTo(this.speaker.model);
							} else {
								this.snackbar.error(resp.message);
							}
						},
						(error: any) => {
							const msg = error?.error?.message || 'Failed to update status';
							this.snackbar.error(msg);
						}
					);
				}
			});
		}
	}

	bulkAction() {
		if (!this.selectedIds.length) return;
		const newStatus: 'active' | 'inactive' = this.activeView ? 'inactive' : 'active';
		const actionLabel = this.activeView ? 'Deactivate' : 'Restore';
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: `${actionLabel} Records`,
			message: `Please enter a remark to ${actionLabel.toLowerCase()} ${this.selectedIds.length} record(s).`,
			requireRemark: true,
			remarkLabel: 'Status Change Remark',
			remarkPlaceholder: `Reason to ${actionLabel.toLowerCase()} these record(s)`,
		};
		const ref = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		ref.afterClosed().subscribe((dialogResult: any) => {
			if (dialogResult) {
				const payload = {
					selectedIds: this.selectedIds,
					status: newStatus,
					remark: dialogResult.remark,
				};
				this.api.callRoute(`${this.speaker.model}`, `/changeStatus`, payload).subscribe(
					(resp: any) => {
						if (resp.status !== 'error') {
							this.snackbar.success(`${actionLabel}d successfully!`);
							this.selection.clear();
							this.selectedIds = [];
							this.speaker.emitPaginationChange(this.pageIndex, this.pageSize, this.sortQuery);
						} else {
							this.snackbar.error(resp.message);
						}
					},
					(error: any) => {
						this.snackbar.error('Failed to update status');
					}
				);
			}
		});
	}

	generateBulk(model: string) {
		switch (model) {
			case 'challan':
				return this.processGenerateBulkProformaInvoices();
			case 'proforma':
				return this.processGenerateBulkInvoices();
			default:
				break;
		}
		return;
	}

	processGenerateBulkInvoices() {
		if (this.selectedIds.length === 0) {
			this.snackbar.warning('Please select at least one record');
			return;
		}
		const payload = { selectedIds: this.selectedIds };

		let message = `Are you sure you want to proceed with the operation?`;
		if (this.speaker.model === 'proforma') {
			message = `Are you sure you want to generate bulk invoices? <br/>This will create invoices for all selected proformas and submit them in bulk.`;
		}
		const model = 'invoice/proforma';
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = { title: 'Generate Bulk Invoices', message: message };
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.dialogBoxResult = dialogResult;
			if (this.dialogBoxResult) {
				this.api.callRoute(`${model}`, `/generateBulk`, payload).subscribe(
					(resp: any) => {
						if (resp.status) {
							this.snackbar.success(resp.message);
							this.redirectTo(this.speaker.model);
						} else {
							this.snackbar.info(resp.message);
						}
					},
					(error: any) => console.log(error)
				);
			}
		});
	}

	processGenerateBulkProformaInvoices() {
		if (this.selectedIds.length === 0) {
			this.snackbar.warning('Please select at least one record');
			return;
		}
		const payload: any = { selectedIds: this.selectedIds };

		let message = `Are you sure you want to proceed with the operation?`;
		if (this.speaker.model === 'challan') {
			message = `Select Company to generate proformas for all selected challans.<br><br>Note:<br>a. Draft proformas will be created for all challans, grouped by doctor.<br>b. Only challans with a "regular" job type will be included.<br>c. Challans that have already been proforma invoiced will be skipped.<br>d. Challans with a "Draft" or "Cancelled" status will not be processed.`;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = { title: 'Generate Bulk Proforma Invoices', message: message, showCompanySelection: true };
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.dialogBoxResult = dialogResult;
			if (this.dialogBoxResult) {
				payload['selectedCompanyId'] = this.dialogBoxResult['selectedCompanyId'];
				this.api.callRoute(`${this.speaker.model}`, `/generateBulk`, payload).subscribe(
					(resp: any) => {
						if (resp.status) {
							this.snackbar.success(resp.message);
							this.redirectTo(this.speaker.model);
						} else {
							this.snackbar.info(resp.message);
						}
					},
					(error: any) => console.log(error)
				);
			}
		});
	}

	redirectTo(uri: string) {
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
			this.router.navigate([uri]));
	}

	setListData(data: any[]) {
		this.listData = data;
	}

	selectAllRecords() {
		this.selectedIds = [...this.allIds];
		this.dataSource.data.forEach(row => {
			if (this.selectedIds.includes(row.id)) {
				this.selection.select(row);
			}
		});
	}

	unselectAllRecords() {
		this.selection.clear();
		this.selectedIds = [];
	}

	replaceNewlinesWithBr(text: string): string {
		return text ? text.replace(/\n/g, '<br>') : '';
	}

	/** Convert snake_case enum values to Title Case (e.g. "in_production" → "In Production") */
	formatEnumValue(value: string): string {
		if (!value) return '';
		return value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
	}
}
